import { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@material-tailwind/react";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import periodsService from "../../services/periods.service";
import Navbar from "../../components/navbar/Navbar";
import './Home.css';


const Home = () => {
    const [currentPeriod, setCurrentPeriod] = useState("[...]");
    const [isActive, setIsActive] = useState<boolean>(true);

    const getCurrentPeriod = async () => {
        let res = await periodsService.getCurrentPeriod();
        if (res) {
            setCurrentPeriod(res.id);
            setIsActive(res.isActive);
        }
    };

    useEffect(() => {
        getCurrentPeriod();
    }, []);

    return (
        <div className="HomePage">
            <Navbar />
            <div className="container-home">
                <h2>¡Bienvenido a Expo Emprendedores {currentPeriod}!</h2>
                <img src="/emprendedores/UABClogos/cimarron-logo.png" alt="cimarron-logo" />
                <a href="/emprendedores/forms/registro_emprendedores">
                    <Button className="bg-gradient-to-tr from-amber-600 to-amber-400 text-white font-bold text-xl py-4 px-8 rounded-lg inline-block" placeholder={""}>
                        Registrar Proyecto
                    </Button>
                </a>
            </div>
        </div>
    );
}

export default Home;